<template>
  <el-row :gutter="10">
    <div class="content">
      <div class="contentinfo" style="padding: 20px 10px 0px 11px;width: 95%">
        <h4>
          高新区建设局施工单位隐患自查自报
        </h4>
        <el-form ref="form" :model="form" style="width: 300px" class="rlx_query_form">
          <el-form-item class="gxq-margin-bottom">
            <label style="float:left">发现人姓名:</label><span style="float:left;color: red">*</span>
            <el-input v-model="form.reportName"></el-input>
          </el-form-item>
          <el-form-item class="gxq-margin-bottom">
            <label style="float:left">手机号:</label><span style="float:left;color: red">*</span>
            <el-input v-model="form.reportPhone"></el-input>
          </el-form-item>
          <el-form-item class="gxq-margin-bottom">
            <label style="float:left">隐患内容:</label><span style="float:left;color: red">*</span>
            <el-input type="textarea" v-model="form.reportContent" rows="6" maxlength="500"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <el-upload :class="{hide:hideUpload}"
                       name="panxList"
                       list-type="picture-card"
                       action="xxx"
                       :on-preview="handlePreview"
                       :file-list="panxList"
                       :multiple="false"
                       accept="image/*"
                       :on-exceed="handleExceed"
                       :http-request = "customUpload"
                       :limit="1"
                       :on-change="handleChange"
                       :before-upload="beforeAvatarUpload"
                       :on-remove="handleRemove"
                       :before-remove="beforeRemove">
              <!--<el-button size="small" type="primary">点击上传</el-button>-->
              <i class="el-icon-plus" ></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit()" :disabled="issubmit">提交</el-button>
            <el-button @click="rollback">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-row>

</template>

<script>
export default {
  data () {
    return {
      path: '',
      date: '',
      id: '',
      ouName: '',
      businessScore: '',
      grade: '',
      color: '',
      isShowQrcode: true,
      promptInfo: '',
      ouId: '',
      deviceInfo: '',
      issubmit: false,
      form: {
        reportName: '',
        reportPhone: '',
        reportContent: '',
        reportType: 'gxq' // 举报类型，高新区的暂定gxq
      },
      isUpload: false,
      imgUrl: '',
      hideUpload: false,
      limitCount: 1,
      panxList: [] //  附件信息
    }
  },
  created () {
    this.ouId = this.$route.query.id // todo 实际开发时要对ouId做校验，确保插入的数据正确
    this.getDevice()
  },
  methods: {
    handlePreview (file) {
      console.log('---------handlePreview--------')
      //      if (file.suffix === 'mp4' || file.suffix === 'ogg' || file.suffix === 'webm') { // 视频类文件
      //        console.log(file)
      //        this.urlPreview = file.url
      //        this.videoVisible = true
      //      } else {
      //        this.urlPreview = file.url
      //        this.visibleDown = true // 下载页面
      //        this.disabledVisible1 = true
      //        // window.open(file.url, file.name, 'height=100, width=400')
      //      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleRemove (file, fileList) {
      // alert("handleRemove")
      this.panxList = fileList
      this.hideUpload = fileList.length >= this.limitCount
      // console.log(fileList)
    },
    handleChange (file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    // 文件上传前验证
    beforeAvatarUpload (file) {
      var obj = file.name.split('.')
      const lastL = obj.length - 1
      const extension9 = obj[lastL] === 'jpg'
      const extension10 = obj[lastL] === 'png'
      if (!extension9 && !extension10) {
        this.$message.warning(' 请选择[jpg、png]格式的照片!')
        return false
      }
      return true //  返回false不会自动上传
    },
    customUpload (params) {
      let loadingInstance = this.$loading({})
      this.$http({
        url: 'app/file/uploadSign',
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 0) {
          // console.log('data=======>', data)
          const filename = params.file.name
          let pos = filename.lastIndexOf('.')
          let suffix
          if (pos !== -1) {
            suffix = filename.substring(pos)
          }
          let imageUrl = ''
          var reader = new FileReader()
          reader.readAsDataURL(params.file)
          reader.onload = function (e) {
            //            console.log('e.target.result=>', e.target.result)
            //            console.log('this.result=>', this.result)
            imageUrl = e.target.result
          }
          let fd = new FormData()
          fd.append('key', data.dir + '/' + data.newname + suffix)
          fd.append('policy', data.policy)
          fd.append('OSSAccessKeyId', data.accessid)
          fd.append('success_action_status', '200') // 让服务端返回200,不然，默认会返回204
          // fd.append('callback', data.callback)
          fd.append('signature', data.signature)
          fd.append('file', params.file)
          this.$http({
            url: data.host,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data;charset=utf-8'
            },
            data: fd,
            timeout: 1000 * 90,
            withCredentials: false
          }).then(res => {
            if (res && res.status === 200) {
              this.panxList.push({
                url: imageUrl,
                name: filename,
                size: params.file.size,
                uuid: data.newname,
                path: data.dir,
                suffix: (suffix && suffix.length > 2) ? suffix.substring(1) : ''
              })
            } else {
              this.$message.error('上传失败，请稍后重试')
            }
          }).catch((e) => {
            console.log('e=>', e)
            this.$message.error('上传失败，请稍后重试')
          }).then(function () {
            loadingInstance.close()
          })
        } else {
          loadingInstance.close()
          this.$message.error('上传失败，请稍后重试')
        }
      }).catch((e) => {
        loadingInstance.close()
        this.$message.error('上传失败，请稍后重试')
      })
    },
    uploadImg (e) {
      this.isUpload = true
      let file = e.target.files[0]
      let url = ''
      var reader = new FileReader()
      reader.readAsDataURL(file)
      let that = this
      reader.onload = function (e) {
        url = this.result.substring(this.result.indexOf(',') + 1)
        that.imgUrl = 'data:image/png;base64,' + url
        that.$refs['imgimg'].setAttribute('src', 'data:image/png;base64,' + url)
      }
    },
    rollback () {
      this.form = {
        reportName: '',
        reportPhone: '',
        reportContent: '',
        reportType: 'gxq'
      }
      this.issubmit = false
      this.panxList = []
      this.hideUpload = false
    },
    onSubmit () {
      this.issubmit = true
      if (!this.form.reportName && !this.form.reportName.trim() && this.form.reportName.trim().length < 1) {
        this.issubmit = false
        this.$message.error('请填写发现人姓名！')
        // this.$notify.error({
        //   title: '错误',
        //   message: '举报内容是必需要填写的，不能为空哦！'
        // });
        return
      }
      if (!this.form.reportPhone && !this.form.reportPhone.trim() && this.form.reportPhone.trim().length < 1) {
        this.issubmit = false
        this.$message.error('请填写手机号！')
        // this.$notify.error({
        //   title: '错误',
        //   message: '举报内容是必需要填写的，不能为空哦！'
        // });
        return
      }
      if (!this.form.reportContent && !this.form.reportContent.trim() && this.form.reportContent.trim().length < 1) {
        this.issubmit = false
        this.$message.error('请填写隐患内容！')
        // this.$notify.error({
        //   title: '错误',
        //   message: '举报内容是必需要填写的，不能为空哦！'
        // });
        return
      }
      var fileList = []
      for (var i = 0; i < this.panxList.length; i++) {
        var fitem = this.panxList[i]
        fitem.url = ''
        fileList.push(fitem)
      }
      this.$http({
        url: 'app/CorpAccuse/save',
        method: 'post',
        data: this.$http.adornData({
          'reportName': this.form.reportName,
          'reportPhone': this.form.reportPhone,
          'reportContent': this.form.reportContent,
          'reportType': this.form.reportType,
          'ouId': this.ouId,
          'deviceInfo': this.deviceInfo,
          'fileList': fileList
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功，谢谢您的反馈！',
            type: 'success',
            duration: 1500
          })
          this.form = {
            reportName: '',
            reportPhone: '',
            reportContent: '',
            reportType: 'gxq'
          }
          this.panxList = []
          this.hideUpload = false
          this.issubmit = false
        } else {
          this.issubmit = false
          this.$message.error(data.msg)
        }
      })
    },
    getDevice () {
      // 判断数组中是否包含某字符串
      //      Array.prototype.contains = function (needle) {
      //        for (i in this) {
      //          if (this[i].indexOf(needle) > 0) { return i }
      //        }
      //        return -1
      //      }

      var deviceType = navigator.userAgent // 获取userAgent信息
      //      // document.write(deviceType); //打印到页面
      //      var md = new MobileDetect(deviceType) // 初始化mobile-detect
      //      var os = md.os() // 获取系统
      //      // console.log(os)
      //      var model
      //      if (os === 'iOS') { // ios系统的处理
      //        os = +md.version('iPhone')
      //        // console.log(os)
      //        model = md.mobile()
      //      } else if (os === 'AndroidOS') { // Android系统的处理
      //        os = md.os() + md.version('Android')
      //        var sss = deviceType.split(';')
      //        var i = sss.contains('Build/')
      //        if (i > -1) {
      //          model = sss[i].substring(0, sss[i].indexOf('Build/'))
      //        }
      //      }
      // alert(os + "---" + model);//打印系统版本和手机型号
      // console.log(model + '||' + os, '打印系统版本和手机型号')
      this.deviceInfo = deviceType
    }
  }
}
</script>

<style>
  .promptInfo{
    height:300px;
    /*width:600px;*/
    /*margin:0px auto;*/
    /*background-color: white;*/
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*height: 456px;*/
    width: 300px;
    margin: 0px auto;
    background-color: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 15px;

  }
  .contentinfo{
    /*height:500px;*/
    /*width:600px;*/
    /*margin:0px auto;*/
    /*background-color: white;*/
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*height: 456px;*/
    width: 400px;
    margin: 1px auto;
    background-color: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 15px;

  }
  .content{
    /*text-align:center;*/
    /*height: 900px;*/
    width: 100%;
  }
.div{
  margin:5px 0 6px 0;
}
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .hide .el-upload--picture-card {
    display: none;
  }
  .el-upload--picture-card {
    width: 100%;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
    height: auto;
  }
  .el-upload-list__item-preview {
    display: none !important;
  }
  .el-upload-list__item-delete {
    position: absolute !important;
  }
  .gxq-margin-bottom {
    margin-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GxqIndex.vue